module.exports = __webpack_public_path__ + "static/img/righttitle.d18d14b4.png";